// Master list of assignable menus (key + label). Shared by the plan-menu
// checklist (SubscriptionPlans), the user-permission screen, and the plan
// feature list on the Subscription page. Keys mirror the sidebar's menuKeys
// (AdminLayout fullMenuStructure) so labels show friendly text everywhere.
export const MENU_LIST = [
  // ── Core ──
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'resturantdashbord', label: 'Restaurant Dashboard' },
  { key: 'QuickBooking', label: 'Quick Booking' },
  { key: 'Reservations', label: 'Table Reservations' },

  // ── Booking ──
  { key: 'manageinventory', label: 'Room Booking' },
  { key: 'HourlyBooking', label: 'Hourly Booking' },
  { key: 'BookingReport', label: 'Manage Bookings' },
  { key: 'HoldRoom', label: 'Hold Room' },
  { key: 'Changeroom', label: 'Update Booking Rooms' },
  { key: 'Calender', label: 'Calendar View' },

  // ── Hotel Master ──
  { key: 'hotels', label: 'Hotel Master' },
  { key: 'rooms/add', label: 'Add Room' },
  { key: 'roomtype', label: 'Room Category Master' },
  { key: 'managepackage', label: 'Manage Package' },
  { key: 'Addonm', label: 'Add-On Master' },

  // ── Manage User ──
  { key: 'ManageUser', label: 'Manage User' },
  { key: 'CreateUser', label: 'User Create' },
  { key: 'UserPermission', label: 'User Permission' },
  { key: 'UserReport', label: 'User Report' },
  { key: 'Customerwallet', label: 'Customer Wallet Report' },

  // ── Manage Agent / Coupon ──
  { key: 'ManageAgent', label: 'Manage Agent / Coupon' },
  { key: 'Agent', label: 'Agent Master' },
  { key: 'Couponmaster', label: 'Coupon Master' },

  // ── Restaurant Order ──
  { key: 'RestaurantOrder', label: 'Restaurant Order' },
  { key: 'CreateOrder', label: 'Create Order' },
  { key: 'Order', label: 'View Room Orders' },
  { key: 'KitchenPendingOrders', label: 'Kitchen Pending Orders' },
  { key: 'KotReport', label: 'KOT Report' },

  // ── Manage Restaurant ──
  { key: 'restaurant', label: 'Manage Restaurant' },
  { key: 'AllCategory', label: 'Department / Category Report' },
  { key: 'Createarea', label: 'Add Area' },
  { key: 'Category', label: 'Add Item Category' },
  { key: 'AddItem', label: 'Add Item' },
  { key: 'AreaPricing', label: 'Area Pricing' },
  { key: 'VariantManagement', label: 'Variant Management' },
  { key: 'StoreMaster', label: 'Store Master' },
  { key: 'ItemStoreMapping', label: 'Item Store Mapping' },
  { key: 'StockTransactionHistory', label: 'Stock Transaction History' },
  { key: 'ItemReport', label: 'Item Report' },
  { key: 'RestaurantInvoiceReport', label: 'Restaurant Invoice Report' },
  { key: 'RestaurantGuestReport', label: 'Restaurant Guests' },

  // ── Other Facility ──
  { key: 'BulkBookings', label: 'Bulk Bookings' },

  // ── Reports ──
  { key: 'Bookingfilter', label: 'Booking Report' },
  { key: 'rooms', label: 'Room List' },
  { key: 'packagereport', label: 'Package Report' },
  { key: 'AddonProfitReport', label: 'Add-On Amount' },
  { key: 'InvoiceReport', label: 'Invoice Report' },
  { key: 'Guestreport', label: 'Guest Report' },
  { key: 'AgentReport', label: 'Agent Report' },
  { key: 'Agentcommissionreport', label: 'Agent Commission Report' },
  { key: 'Holdreport', label: 'Hold / Maintenance Rooms' },
  { key: 'NightAuditReport', label: 'Night Audit' },
  { key: 'GstReports', label: 'GST Reports' },
  { key: 'ActivityLog', label: 'Activity Log' },
  { key: 'SubscriptionPaymentReport', label: 'Subscription Payments' },

  // ── Purchase ──
  { key: 'mainpurchase', label: 'Purchase' },
  { key: 'StockDashboard', label: 'Stock Dashboard' },
  { key: 'SupplierMaster', label: 'Supplier Master' },
  { key: 'StorePurchase', label: 'Store Purchase' },
  { key: 'RecipeMaster', label: 'Recipe Master' },
  { key: 'PurchaseReports', label: 'Purchase Reports' },

  // ── Payments ──
  { key: 'Paymentreport', label: 'Payment' },
  { key: 'PettyCashManagement', label: 'Petty Cash Management' },

  // ── Misc / legacy (kept so existing grants & DB menus still resolve) ──
  { key: 'TableOrders', label: 'View Table Orders' },
  { key: 'QuickBill', label: 'Quick Bill' },
  { key: 'hotels/add', label: 'Add Hotel' },
  { key: 'banquethall/add', label: 'Add Banquet Hall' },
  { key: 'availableroom', label: 'Available Room' },
  { key: 'MenuMaster', label: 'Menu Management' },
  { key: 'SupportTickets', label: 'Support / Complaints' },
];

export default MENU_LIST;
